module.exports = __webpack_public_path__ + "img/france-blood-diseases-male.44100a78.png";